import * as ReactHelmetAsync from 'react-helmet-async';
const Helmet = ReactHelmetAsync.Helmet || (ReactHelmetAsync as any).default?.Helmet;
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/layout/Navigation';
import { Footer } from '@/components/layout/Footer';
import { PageHero } from '@/components/sections/PageHero';

export function CfiSpinTraining() {
  return (
    <>
      <Helmet>
        <title>CFI Spin Training | Total Tailwheel</title>
        <meta
          name="description"
          content="CFI spin training in our Cessna 170B. Satisfy FAR 61.183 spin training requirements near Boston at Minute Man Air Field in Stow, MA."
        />
        <link rel="canonical" href="https://totaltailwheel.com/training/cfi-spin-training" />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        <Navigation />
        <PageHero title="CFI Spin Training" />

        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto">
              <div className="bg-white p-8 rounded-lg shadow-md">
                <p className="text-foreground/80 mb-4">
                  CFI applicants must demonstrate instructional knowledge of spin entry, spins, and spin recovery per{' '}
                  <a
                    href="https://www.ecfr.gov/current/title-14/chapter-I/subchapter-D/part-61/subpart-H/section-61.183"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary underline hover:text-primary/80"
                  >
                    FAR 61.183
                  </a>
                  . Our Cessna 170B is an excellent platform for this training — it provides clear aerodynamic
                  feedback and predictable spin characteristics.
                </p>

                <p className="text-foreground/80 mb-4">
                  N3472C's larger cabin and higher gross weight make it a great option for pilots who don't
                  fit comfortably in a Cessna 150/152 or Decathlon — the aircraft typically used for spin training.
                </p>

                <p className="text-foreground/80 mb-6">
                  You'll receive a logbook endorsement upon completion, satisfying the spin training requirement
                  for your CFI checkride.
                </p>

                <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 mb-6">
                  <p className="text-sm text-foreground/70">
                    Located at <strong>Minute Man Air Field (6B6)</strong> in Stow, MA — just 30 minutes west of Boston,
                    with easy access from Route 2 and Route 495.
                  </p>
                </div>

                <div className="text-center">
                  <Link
                    to="/inquire"
                    className="inline-block bg-primary text-white px-6 py-3 rounded-lg hover:bg-primary/90 transition-colors font-medium"
                  >
                    Inquire Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}
